import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthScreen } from "@/components/auth/auth-screen";
import { hrEmployerApi } from "@/lib/api/hr";
import { setHrEmployerSession } from "@/lib/auth/storage";
import { ApiError } from "@/lib/api/client";

export default function EmployerLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await hrEmployerApi.login(email.trim(), password);
      setHrEmployerSession({
        token: res.token,
        role: "hr_employer",
        employer: res.employer,
      });
      navigate("/employer");
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : "Could not sign in. Try again."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthScreen
      title="Employer sign in"
      description="Manage employee profiles, leave, tasks, and performance."
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="h-12 text-base"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="h-12 text-base"
          />
        </div>
        {error && (
          <p className="text-sm text-red-600" role="alert">
            {error}
          </p>
        )}
        <Button type="submit" className="h-12 w-full text-base" size="lg" disabled={loading}>
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </AuthScreen>
  );
}
